import { Grid } from "@mui/material";
import { MxJiraCustomComponentProps } from "@rf-l1/form/selects/MxAutoCompleteField/model/MxAutoCompleteField";
import { AutoCompleteItemOption } from "@rf-l1/form/selects/MxAutoCompleteField/MxAutoCompleteField";
import MxTypography from "@rf-l1/MxTypography";
import { sectorAutoCompleteItem } from "@rf/adapters/autocomplete-items/sectorItemAdapters";

function MxItemsSectorWithCity(
  props: MxJiraCustomComponentProps<sectorAutoCompleteItem>
) {
  const { item, ...rest } = props;
  return (
    <AutoCompleteItemOption {...rest}>
      <Grid container>
        <Grid item xs={12}>
          <MxTypography variant="overline" fontWeight={600} color="grey.600">
            {item?.label}
          </MxTypography>
        </Grid>

        <Grid item xs={12}>
          <MxTypography variant="overline" color="grey.500">
            {item?.extraData?.city}
          </MxTypography>
        </Grid>
      </Grid>
    </AutoCompleteItemOption>
  );
}

export default MxItemsSectorWithCity;
